import { euro } from '../lib/api';
import type { FunnelBucket } from '../../shared/kpi';

/**
 * Waagerechte Balken statt Trichtergrafik: auf dem Handy bleibt der Stufenname
 * lesbar, und die Zahl steht daneben statt in der Grafik.
 */
export function Funnel({
  buckets,
  variant = 'deals',
  showAmount = true,
}: {
  buckets: FunnelBucket[];
  variant?: 'deals' | 'leads';
  showAmount?: boolean;
}) {
  const max = Math.max(1, ...buckets.map((b) => b.count));
  if (buckets.every((b) => b.count === 0)) {
    return <p className="card__meta">Keine offenen Einträge.</p>;
  }
  return (
    <div className="sm-funnel">
      {buckets.map((b) => (
        <div className="sm-funnel__row" key={b.stage}>
          <span className="sm-funnel__stage">{b.stage}</span>
          <span className="sm-funnel__track">
            <span
              className={`sm-funnel__bar${variant === 'leads' ? ' sm-funnel__bar--lead' : ''}`}
              style={{ width: `${Math.round((b.count / max) * 100)}%` }}
            />
          </span>
          <span className="sm-funnel__num mono">
            {b.count}
            {/*
              Betrag nur zeigen, wenn einer hinterlegt ist – und dann mit dem
              Hinweis, wie viele Deals dieser Stufe ohne Betrag sind. `Amount`
              ist im CRM nur teilweise gefuellt; eine Summe ohne diesen Zusatz
              taeuscht Genauigkeit vor.
            */}
            {showAmount && b.amount > 0 ? (
              <span className="card__meta">
                {' · '}
                {euro(b.amount)}
                {b.withoutAmount > 0 ? ` (+${b.withoutAmount} o. B.)` : ''}
              </span>
            ) : null}
          </span>
        </div>
      ))}
    </div>
  );
}
